import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import { pushTitle } from '../../../../actions/historyActions';
import _ from 'lodash';
import React, { Component } from 'react';
import './styles.scss';
import { getCardViewState } from '../../selectors/ehubSelector';
import { resolveLocalizedText, resolvePublicAssets } from '../../../../utils';
import { CardViewState } from '../../reducers';
import EmmaModalView from '../../../../components/EmmaModalView';
import {
  goTo,
  fetchEHubAuthToken,
  openEHubDisclaimer,
} from '../../actions/ehubAction';
import { openDisclaimer } from '../../../../modules/emma-common/actions';

export interface GenericDetailsViewProps {
  cardViewId: string;
  isLocked?: boolean;
  title?: string;
  subtitle?: string;
  fullDesc?: string;
  icon?: string;
  picture?: string;
  disclaimerId?: string;
  disclaimerLockId?: string;
  url?: string;
  btnText?: string;
  onPushTitle: (title: string) => void;
  onClickTryNow: (
    cardViewId: string,
    isLocked: boolean,
    url?: string,
    disclaimerId?: string,
    disclaimerLockId?: string,
  ) => void;
}

export class GenericDetailsView extends Component<
  GenericDetailsViewProps,
  CardViewState
> {
  constructor(props: any = {}) {
    super(props);
  }

  componentDidMount() {
    const { onPushTitle } = this.props;
    onPushTitle('');
  }

  render() {
    const {
      cardViewId,
      isLocked,
      title,
      subtitle,
      fullDesc,
      icon,
      picture,
      url,
      disclaimerId,
      disclaimerLockId,
      btnText,
      onClickTryNow,
    } = this.props;

    return (
      <div className="e-hub-details-view">
        {icon && (
          <div className="e-hub-details-view__icon-container">
            <img className="e-hub-details-view__icon" src={icon} />
          </div>
        )}
        {title && <div className="e-hub-details-view__title">{title}</div>}
        {subtitle && (
          <div className="e-hub-details-view__subtitle">{subtitle}</div>
        )}
        {picture && (
          <div
            className="e-hub-details-view__bg-picture"
            style={{ backgroundImage: `url(${picture})` }}
          ></div>
        )}
        {fullDesc && (
          <div
            className="e-hub-details-view__full-desc"
            dangerouslySetInnerHTML={{ __html: memoSanitize(fullDesc) }}
          ></div>
        )}

        <div className="e-hub-details-view__button-wrapper">
          <span
            tabIndex={0}
            className="e-hub-details-view__btn-link cursor-pointer"
            onClick={() => {
              onClickTryNow(
                cardViewId,
                isLocked || false,
                url,
                disclaimerId,
                disclaimerLockId,
              );
            }}
            data-enable-ga
            data-ga-type="button"
          >
            {btnText}
          </span>
        </div>
        <EmmaModalView />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const cardViewState = getCardViewState(state, ownProps.cardViewId);
    const disclaimerId = _.get(
      cardViewState.deepLink,
      'query.disclaimer',
      undefined,
    );
    const disclaimerLockId = _.get(
      cardViewState.deepLinkLock,
      'query.disclaimer',
      undefined,
    );
    const url: string = resolveLocalizedText(
      _.get(cardViewState.deepLink, 'query.url', {}),
    );
    const btnText: string = resolveLocalizedText(
      _.get(cardViewState.deepLink, 'query.label', {}),
    );

    return {
      title: cardViewState.title
        ? resolveLocalizedText(cardViewState.title)
        : '',
      subtitle: cardViewState.subtitle
        ? resolveLocalizedText(cardViewState.subtitle)
        : '',
      icon: resolvePublicAssets(cardViewState.icon).replace('.png', '@3x.png'),
      picture: resolvePublicAssets(cardViewState.picture).replace(
        '.png',
        '@3x.png',
      ),
      fullDesc: cardViewState.fullDesc
        ? resolveLocalizedText(cardViewState.fullDesc)
        : '',
      disclaimerId: disclaimerId,
      disclaimerLockId: disclaimerLockId,
      url: url,
      btnText: btnText,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onPushTitle: (title: string) => dispatch(pushTitle(title)),
      onClickTryNow: (
        cardViewId: string,
        isLocked: boolean,
        url?: string,
        disclaimerId?: string,
        disclaimerLockId?: string,
      ) => {
        if (isLocked && disclaimerLockId) {
          dispatch(openDisclaimer(disclaimerLockId));
        } else if (isLocked) {
          return;
        } else if (disclaimerId) {
          dispatch(openEHubDisclaimer(disclaimerId, cardViewId));
        } else if (url) {
          dispatch(goTo(cardViewId, url));
        }
      },
    };
  }
}
